// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.shapeshift",
    name: "ShapeShift",
    homepage: "https://shapeshift.com",
    image_id: "f8de2385-7d9b-4b31-bfed-5555b14fad00",
    app: {
        browser: "https://app.shapeshift.com",
        ios: "https://apps.apple.com/us/app/shapeshift-crypto-platform/id996569075",
        android: "https://play.google.com/store/apps/details?id=com.shapeshift.droid_shapeshift&hl=en_US&gl=US&pli=1",
        mac: "https://apps.apple.com/us/app/shapeshift-crypto-platform/id996569075",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://shapeshift.app.link/",
    },
    desktop: {
        native: null,
        universal: "https://app.shapeshift.com",
    },
};
//# sourceMappingURL=index.js.map